import { createAction, props } from '@ngrx/store';

export const SET_COMMON_ORDER_REFERENCE = '[common order] Set common order reference';

export const setCommonOrderReference = createAction(SET_COMMON_ORDER_REFERENCE, props<{ orderReference: string }>());
